import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import { GlobalModalService } from '../shared/global-modal/global-modal.service';
import { LoggerService } from '../services/logger.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  profileForm: FormGroup;
  passwordForm: FormGroup;
  
  userProfile: any = null;
  loading: boolean = true;
  isSaving: boolean = false;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private modalService: GlobalModalService,
    private logger: LoggerService
  ) {
    this.profileForm = this.fb.group({
      nombre: [''],
      apellidos: [''],
      idioma: ['es'],
      timezone: ['Europe/Madrid']
    });

    this.passwordForm = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    this.loadProfile();
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('newPassword')?.value === g.get('confirmPassword')?.value
      ? null : { 'mismatch': true };
  }

  loadProfile() {
    this.userService.getMyProfile().subscribe({
      next: (data) => {
        this.userProfile = data;
        this.profileForm.patchValue({
          nombre: data.nombre || '',
          apellidos: data.apellidos || '',
          idioma: data.idioma || 'es',
          timezone: data.timezone || 'Europe/Madrid'
        });
        this.loading = false;
      },
      error: (err) => {
        this.logger.error("Error al cargar el perfil", err);
        this.loading = false;
      }
    });
  }

  saveProfile() {
    if (this.profileForm.invalid) return;
    this.isSaving = true;

    this.userService.updateMyProfile(this.profileForm.value).subscribe({
      next: (data) => {
        this.userProfile = { ...this.userProfile, ...data }; 
        this.modalService.showSuccess("Perfil Actualizado", "Tus datos personales han sido guardados correctamente.");
        this.isSaving = false;
      },
      error: (err) => {
        this.logger.error("Error actualizando perfil", err);
        this.isSaving = false;
      }
    });
  }

  changePassword() {
    if (this.passwordForm.invalid) return;

    const payload = {
      currentPassword: this.passwordForm.value.currentPassword,
      newPassword: this.passwordForm.value.newPassword
    };

    this.userService.changeMyPassword(payload).subscribe({
      next: () => {
        this.modalService.showSuccess("Seguridad", "Tu contraseña ha sido actualizada con éxito.");
        this.passwordForm.reset();
      },
      error: (err) => {
        this.logger.error("Error cambiando contraseña", err);
      }
    });
  }

  get tokenPercentage(): number {
    if (!this.userProfile || !this.userProfile.totaltokens) return 0;
    return Math.min(100, Math.round((this.userProfile.consumedtokens / this.userProfile.totaltokens) * 100));
  }
}